// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main{
    height: 70vh;
    width: 30%;
    position: absolute;
    margin: 1% 0% 0 0%;
    left: 40%;   
}

.link:hover{
color: black;
}
.inp
{
    width: 90%;
    height: auto;
    border: 1px solid rgb(175, 175, 175);
    border-radius: 1vh;
    margin: 2%;
    padding: 3%;
}
.imp
{
  width: 95%; /* Match other input fields */
  height: 2.9em; /* Same height as other fields */
  border: none; /* Remove the outer border */
  border-bottom: 0px solid rgb(175, 175, 175); /* Add a bottom border if needed */
  border-radius: 0; /* Match other input fields' border style */
  padding: 0.5em; /* Match padding with other fields */
  font-size: 1em; /* Ensure font consistency */
  outline: none; /* Remove focus outline */
  box-sizing: border-box; /* Ensure padding doesn't affect dimensions */
}
.inp:hover{
    border: 2px solid #03b4c6;

}
.btn
{
  width:20vw;
    padding: 3% 6% 3% 6%;
    background-color: white;
    font-weight: bold;
    color: #03b4c6;
    font-family: sans-serif;
    border: 2px solid #03b4c6;
    border-radius: 1vh;
    margin: 3% 0 0% 10%;
    text-align: center;
    word-wrap: break-word;
    
}
.btn:hover{
    background-color: #03b4c6;
    color:white ;
}
 
.UserDropdown
{
    font-size: 20px;
    color: #03b4c6;
}
.UserDropdown:hover
{
    color: white !important;
    background-color:#03b4c6;
}
 
   .dropdown-container {
    position: relative;
    display: inline-block; 
  }
    
  .dropdown-menu_ {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 999;
    background-color: #edffff;
    border: 1px solid #03b4c6; 
  }
  
  .course-text {
    display: block;
    white-space: normal;
    overflow-wrap: break-word;
  }
  
  
  
  .overlay1133,.overlay1122 {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); 
    z-index: 9998;
  }
  .popup{
    height: 70vh;
    width: 100%;
    background-color: rgb(255, 255, 255);
    position: absolute; 
    overflow-x:inherit;
    overflow-y:auto;
    padding-left: 5%;
}
.popup-header{
    display: flex;
    justify-content: space-between;
    padding: 0 30px 0 15px; 
}

.SignUP-avatar-upload {
  display: flex;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-color: #e0e0e0;
  text-align: center;
  cursor: pointer;
  overflow: hidden;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.SignUP-avatar-upload img {
  max-width: 100%;
  max-height: 100%;
}
.Signupbtn
{
  border: 0;
  border-radius: 0;
  
}

.Navbar-Right-Aligned
{
  justify-content: flex-end; 
}
.user-profile-dropdown
{
  border:1px  solid #03b4c6;
  background-color:#edffff;
  margin-left: -80%;
}
.pageLogo
{
   width: 40%; 
   height: auto;
}
@media only screen and (max-width: 1000px)
{
  .pageLogo{
    width: 30%;
  }
  .main
  {     
      margin-left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 95%;
      left: 0;
      margin-left: 2%;
      top: 20%;
  }
  .popup
  {
    padding-left: 0;
    margin-left: 1%;
    margin-right: 1%;
  }
  .btn{
    width: 80%;
  }
  .user-profile-dropdown
  {
    width: 80%;
    margin: 0;
  }
}




.modal-content{
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.AttendClassButton{

  background-color: #03b4c6;
  color: white;
  font-weight: normal;
  border: none;
  border-radius: 3vh;
  width: 50%;
  padding: 2vh;
  font-size: large;
}
.AttendClassDropdown
{
  width: 50%;
  height: auto;
  padding: 2vh;
  border: none;
  margin: 2vh;

}

.dropdown-menu-scrollable {
  max-height: 300px;
  overflow-y: auto;
}
/* Modal Overlay */
.modal-overlays {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  gap: 30px;
}

/* Modal Content */
.modal-contents {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  width: 300px;
  gap: 30px;
}

/* Redeem Button */
.redeem-buttons {
  background-color: #1d36c2;
  color: rgba(255, 255, 255, 0.781);
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  /* cursor: not-allowed; */
  opacity: 0.6;
  margin-top: 10px;
  gap: 30px;
}

/* Close Button */
.close-buttons {
  background-color: #f34d4d;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 10px;
}

.close-buttons:hover {
  background-color: #999;
}
.button-container {
  display: flex;
  align-items: center;
  align-self: center;
  align-content: center;
  gap: 10px; /* Adjust this value as needed */
  margin-top: 10px;
  margin-left: 20px;
}`, "",{"version":3,"sources":["webpack://./src/MyComponents/Navbars/Nav.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;AACb;;AAEA;AACA,YAAY;AACZ;AACA;;IAEI,UAAU;IACV,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;AACA;;EAEE,UAAU,EAAE,6BAA6B;EACzC,aAAa,EAAE,gCAAgC;EAC/C,YAAY,EAAE,4BAA4B;EAC1C,2CAA2C,EAAE,kCAAkC;EAC/E,gBAAgB,EAAE,2CAA2C;EAC7D,cAAc,EAAE,oCAAoC;EACpD,cAAc,EAAE,4BAA4B;EAC5C,aAAa,EAAE,yBAAyB;EACxC,sBAAsB,EAAE,6CAA6C;AACvE;AACA;IACI,yBAAyB;;AAE7B;AACA;;EAEE,UAAU;IACR,oBAAoB;IACpB,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;IACd,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;;AAEzB;AACA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;;IAEI,eAAe;IACf,cAAc;AAClB;AACA;;IAEI,uBAAuB;IACvB,wBAAwB;AAC5B;;GAEG;IACC,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,yBAAyB;EAC3B;;;;EAIA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,SAAS;EACT,gBAAgB;;AAElB;;AAEA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;EACzB,wBAAwB;EACxB,iBAAiB;AACnB;AACA;;GAEG,UAAU;GACV,YAAY;AACf;AACA;;EAEE;IACE,UAAU;EACZ;EACA;;MAEI,cAAc;MACd,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,UAAU;MACV,OAAO;MACP,eAAe;MACf,QAAQ;EACZ;EACA;;IAEE,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;EACA;;IAEE,UAAU;IACV,SAAS;EACX;AACF;;;;;AAKA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,WAAW;;AAEb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,YAAY;EACZ,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,SAAS,EAAE,gCAAgC;EAC3C,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".main{\n    height: 70vh;\n    width: 30%;\n    position: absolute;\n    margin: 1% 0% 0 0%;\n    left: 40%;   \n}\n\n.link:hover{\ncolor: black;\n}\n.inp\n{\n    width: 90%;\n    height: auto;\n    border: 1px solid rgb(175, 175, 175);\n    border-radius: 1vh;\n    margin: 2%;\n    padding: 3%;\n}\n.imp\n{\n  width: 95%; /* Match other input fields */\n  height: 2.9em; /* Same height as other fields */\n  border: none; /* Remove the outer border */\n  border-bottom: 0px solid rgb(175, 175, 175); /* Add a bottom border if needed */\n  border-radius: 0; /* Match other input fields' border style */\n  padding: 0.5em; /* Match padding with other fields */\n  font-size: 1em; /* Ensure font consistency */\n  outline: none; /* Remove focus outline */\n  box-sizing: border-box; /* Ensure padding doesn't affect dimensions */\n}\n.inp:hover{\n    border: 2px solid #03b4c6;\n\n}\n.btn\n{\n  width:20vw;\n    padding: 3% 6% 3% 6%;\n    background-color: white;\n    font-weight: bold;\n    color: #03b4c6;\n    font-family: sans-serif;\n    border: 2px solid #03b4c6;\n    border-radius: 1vh;\n    margin: 3% 0 0% 10%;\n    text-align: center;\n    word-wrap: break-word;\n    \n}\n.btn:hover{\n    background-color: #03b4c6;\n    color:white ;\n}\n \n.UserDropdown\n{\n    font-size: 20px;\n    color: #03b4c6;\n}\n.UserDropdown:hover\n{\n    color: white !important;\n    background-color:#03b4c6;\n}\n \n   .dropdown-container {\n    position: relative;\n    display: inline-block; \n  }\n    \n  .dropdown-menu_ {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 999;\n    background-color: #edffff;\n    border: 1px solid #03b4c6; \n  }\n  \n  .course-text {\n    display: block;\n    white-space: normal;\n    overflow-wrap: break-word;\n  }\n  \n  \n  \n  .overlay1133,.overlay1122 {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5); \n    z-index: 9998;\n  }\n  .popup{\n    height: 70vh;\n    width: 100%;\n    background-color: rgb(255, 255, 255);\n    position: absolute; \n    overflow-x:inherit;\n    overflow-y:auto;\n    padding-left: 5%;\n}\n.popup-header{\n    display: flex;\n    justify-content: space-between;\n    padding: 0 30px 0 15px; \n}\n\n.SignUP-avatar-upload {\n  display: flex;\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  background-color: #e0e0e0;\n  text-align: center;\n  cursor: pointer;\n  overflow: hidden;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.SignUP-avatar-upload img {\n  max-width: 100%;\n  max-height: 100%;\n}\n.Signupbtn\n{\n  border: 0;\n  border-radius: 0;\n  \n}\n\n.Navbar-Right-Aligned\n{\n  justify-content: flex-end; \n}\n.user-profile-dropdown\n{\n  border:1px  solid #03b4c6;\n  background-color:#edffff;\n  margin-left: -80%;\n}\n.pageLogo\n{\n   width: 40%; \n   height: auto;\n}\n@media only screen and (max-width: 1000px)\n{\n  .pageLogo{\n    width: 30%;\n  }\n  .main\n  {     \n      margin-left: 0;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 95%;\n      left: 0;\n      margin-left: 2%;\n      top: 20%;\n  }\n  .popup\n  {\n    padding-left: 0;\n    margin-left: 1%;\n    margin-right: 1%;\n  }\n  .btn{\n    width: 80%;\n  }\n  .user-profile-dropdown\n  {\n    width: 80%;\n    margin: 0;\n  }\n}\n\n\n\n\n.modal-content{\n  width: 40%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.AttendClassButton{\n\n  background-color: #03b4c6;\n  color: white;\n  font-weight: normal;\n  border: none;\n  border-radius: 3vh;\n  width: 50%;\n  padding: 2vh;\n  font-size: large;\n}\n.AttendClassDropdown\n{\n  width: 50%;\n  height: auto;\n  padding: 2vh;\n  border: none;\n  margin: 2vh;\n\n}\n\n.dropdown-menu-scrollable {\n  max-height: 300px;\n  overflow-y: auto;\n}\n/* Modal Overlay */\n.modal-overlays {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  gap: 30px;\n}\n\n/* Modal Content */\n.modal-contents {\n  background-color: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  width: 300px;\n  gap: 30px;\n}\n\n/* Redeem Button */\n.redeem-buttons {\n  background-color: #1d36c2;\n  color: rgba(255, 255, 255, 0.781);\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  /* cursor: not-allowed; */\n  opacity: 0.6;\n  margin-top: 10px;\n  gap: 30px;\n}\n\n/* Close Button */\n.close-buttons {\n  background-color: #f34d4d;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-top: 10px;\n}\n\n.close-buttons:hover {\n  background-color: #999;\n}\n.button-container {\n  display: flex;\n  align-items: center;\n  align-self: center;\n  align-content: center;\n  gap: 10px; /* Adjust this value as needed */\n  margin-top: 10px;\n  margin-left: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
